exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fmcy-loader-expanded {\n  background-color: #ffffff;\n  overflow: hidden;\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0; }\n  .fmcy-loader-expanded.dark {\n    background-color: #000000; }\n  .fmcy-loader-expanded .fmcy-loader-expanded-default-content-wrapper {\n    display: table;\n    margin: auto;\n    height: 80vh;\n    padding: 10px; }\n  .fmcy-loader-expanded .fmcy-loader-expanded-default-content {\n    max-width: 400px;\n    text-align: center;\n    display: table-cell;\n    vertical-align: middle; }\n", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/sass-loader/lib/loader.js?name=../css/[name]-[hash].[ext]!./assets/js/common/loader-expanded/loader-expanded/loader-expanded.scss
 ** module id = 1011
 ** module chunks = 1 177
 **/